import { useEffect } from "react";
import "@/App.css";
import "lenis/dist/lenis.css";
import { ReactLenis } from "lenis/react";
import Landing from "@/pages/Landing";

function App() {
  useEffect(() => {
    document.title = "MyPT — Mobile Personal Trainer | Chelmsford & Essex";
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App">
        <div className="noise-overlay" aria-hidden="true" />
        <Landing />
      </div>
    </ReactLenis>
  );
}

export default App;
